import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { obtenerProveedores, crearProveedor } from "../redux/actions/index";
import Swal from "sweetalert2";

const AltaProveedor = () => {
  const dispatch = useDispatch();
  const proveedores = useSelector((state) => state.proveedores);
  const [nombre, setNombre] = useState("");
  const [direccion, setDireccion] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    dispatch(obtenerProveedores());
  }, [dispatch]);

  const handleCrearProveedor = async () => {
    if (nombre && direccion && email) {
      try {
        await dispatch(crearProveedor({ nombre, direccion, email }));
        Swal.fire("Éxito", "Proveedor registrado correctamente", "success");
        setNombre("");
        setDireccion("");
        setEmail("");
        dispatch(obtenerProveedores());
      } catch (error) {
        Swal.fire("Error", "No se pudo registrar el proveedor", "error");
      }
    } else {
      Swal.fire("Advertencia", "Todos los campos son obligatorios", "warning");
    }
  };

  return (
    <div className="grid bg-backgroundClaro grid-cols-1 md:grid-cols-2 min-h-screen h-full w-full">
      {/* Formulario de registro */}
      <div className="bg-backgroundOscuro rounded-lg m-4 p-8">
        <h1 className="text-3xl font-bold text-textoClaro mb-4">Registrar Proveedor</h1>
        <div className="space-y-4">
          <div>
            <label className="block text-textoClaro">Nombre</label>
            <input
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
              placeholder="Nombre del proveedor"
            />
          </div>
          <div>
            <label className="block text-textoClaro">Dirección</label>
            <input
              type="text"
              value={direccion}
              onChange={(e) => setDireccion(e.target.value)}
              className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
              placeholder="Dirección del proveedor"
            />
          </div>
          <div>
            <label className="block text-textoClaro">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
              placeholder="Correo electrónico"
            />
          </div>
          <button
            onClick={handleCrearProveedor}
            className="bg-green-900 w-full flex items-center my-2 p-2 rounded-md text-textoClaro font-bold text-lg hover:bg-green-600 shadow-lg shadow-green-500/50"
          >
            Registrar Proveedor
          </button>
        </div>
      </div>

      {/* Lista de proveedores */}
      <div className="bg-backgroundOscuro rounded-lg m-4 p-8">
        <h2 className="text-4xl font-bold text-textoClaro mb-4">Lista de Proveedores</h2>
        <ul className="flex flex-wrap gap-4">
          {proveedores.map((proveedor) => (
            <li
              key={proveedor.id}
              className="bg-backgroundClaro p-4 rounded-lg shadow-md w-full lg:w-[calc(50%-1rem)]"
            >
              <h3 className="text-textoOscuro font-semibold">{proveedor.nombre}</h3>
              <p className="text-textoOscuro">Dirección: {proveedor.direccion}</p>
              <p className="text-textoOscuro">Email: {proveedor.email}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AltaProveedor;